module.exports = __webpack_public_path__ + "img/elecsnet_logo.7821f11e.svg";